import { all, fork } from 'redux-saga/effects';
import quotesSaga from './quotesSaga';
import positionSaga from './positionSaga';
import historySaga from './historySaga';
import loginSaga from './loginSaga';
import tradingSaga from './tradingSaga';
import brokerSaga from './brokerSaga';
import accountHistorySaga from './accountHistorySaga';
import apiListenerSaga from './apiListenerSaga';
import instrumentsSaga from './instrumentsSaga';
import errorSaga from './errorSaga';
import leaderboardSaga from './leaderboardSaga';
import continuousSaga from './continuousSaga';
import timeoutSaga from './timeoutSaga';
import candlesSaga from './candlesSaga';
import userSaga from './userSaga';
function* rootSaga() {
    yield all([
        fork(userSaga),
        fork(quotesSaga),
        fork(positionSaga),
        fork(historySaga),
        fork(candlesSaga),
        fork(loginSaga),
        fork(tradingSaga),
        fork(brokerSaga),
        fork(accountHistorySaga),
        fork(instrumentsSaga),
        fork(errorSaga),
        fork(leaderboardSaga),
        fork(continuousSaga),
        fork(timeoutSaga),
        fork(apiListenerSaga),
    ]);
}
export default rootSaga;
